/**
 * Google Drive connector — single source of truth for all Google Drive metadata.
 * SVG source: https://github.com/simple-icons/simple-icons/blob/develop/icons/googledrive.svg
 */

module.exports = {
  id:          'google_drive',
  name:        'Google Drive',
  enabled:     false,
  iconBg:      '#4285F4',
  svgPath:     'M12.01 1.485c-2.082 0-3.754.02-3.743.047.01.02 1.708 3.001 3.774 6.62l3.76 6.574h3.76c2.081 0 3.753-.02 3.742-.047-.005-.02-1.708-3.001-3.775-6.62l-3.76-6.574zm-4.76 1.73a789.828 789.861 0 0 0-3.63 6.319L0 15.868l1.89 3.298 1.885 3.297 3.62-6.335 3.618-6.33-1.88-3.287C8.1 4.704 7.255 3.22 7.25 3.214zm2.259 12.653-.203.348c-.114.198-.96 1.672-1.88 3.287a423.93 423.948 0 0 1-1.698 2.97c-.01.026 3.24.042 7.222.042h7.244l1.796-3.157c.992-1.734 1.85-3.23 1.906-3.323l.104-.167h-7.249z',

  tagline:     'Pull docs, briefs, and research notes from Drive into agent context.',
  description: 'Connect Google Drive so agents can read files and documents relevant to your strategy — briefs, research outputs, and decision records — without leaving their workflow.',
  useCases: [
    'Read strategy docs and briefs before generating recommendations',
    'Pull research files into brief and PRD generation',
    'Surface relevant documents when agents reason about scope',
  ],
};
